import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoClearbit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 151 48"
    {...props}
  >
    <g
      fillRule="evenodd"
      clipPath="url(#Logo_Clearbit_svg__a)"
      clipRule="evenodd"
    >
      <path
        fill="url(#Logo_Clearbit_svg__b)"
        d="M44.615 24v10.249l-.003.53c-.036 3.688-.458 5.104-1.221 6.531a8.33 8.33 0 0 1-3.465 3.466l-.2.104c-1.431.731-2.958 1.12-6.862 1.12H22.615V24z"
      />
      <path
        fill="url(#Logo_Clearbit_svg__c)"
        d="M39.926 3.224A8.33 8.33 0 0 1 43.39 6.69l.104.2c.732 1.431 1.12 2.958 1.12 6.862V24h-22V2h10.249c4.086 0 5.568.425 7.062 1.224"
      />
      <path
        fill="url(#Logo_Clearbit_svg__d)"
        d="M22.615 2v44H12.366l-.53-.002c-3.688-.037-5.104-.459-6.532-1.222A8.33 8.33 0 0 1 1.84 41.31l-.104-.199C1.003 39.68.615 38.153.615 34.25V13.75c0-4.086.425-5.568 1.224-7.062a8.33 8.33 0 0 1 3.465-3.465l.2-.104C6.935 2.388 8.462 2 12.366 2z"
      />
      <path
        fill="#27282A"
        d="M75.644 18.565a3.98 3.98 0 0 0-1.799-1.368 6 6 0 0 0-2.168-.43q-1.356 0-2.464.492-1.11.493-1.91 1.355a6 6 0 0 0-1.232 2.02 7.2 7.2 0 0 0-.431 2.514q0 1.429.419 2.612a5.9 5.9 0 0 0 1.195 2.033 5.4 5.4 0 0 0 1.86 1.318q1.084.468 2.44.468 1.405 0 2.488-.554a4.86 4.86 0 0 0 1.75-1.466l2.488 1.749a8 8 0 0 1-2.833 2.255q-1.675.8-3.918.8-2.045 0-3.758-.677a8.7 8.7 0 0 1-2.944-1.898 8.6 8.6 0 0 1-1.922-2.907q-.69-1.688-.69-3.733 0-2.094.727-3.782a8.4 8.4 0 0 1 1.996-2.87 8.9 8.9 0 0 1 2.994-1.824q1.725-.64 3.745-.64.837 0 1.75.16.91.159 1.749.492a8.5 8.5 0 0 1 1.577.826q.739.492 1.256 1.182zm4.46-5.273h2.957V31.92h-2.957zm14.002 11.532q0-.567-.16-1.085a2.5 2.5 0 0 0-.505-.911 2.5 2.5 0 0 0-.875-.629q-.53-.234-1.244-.234-1.33 0-2.255.801t-1.022 2.058zm2.957 1.33v.394q0 .198-.025.395h-8.993a2.93 2.93 0 0 0 1.084 2.082 3.7 3.7 0 0 0 1.06.603q.59.222 1.232.222 1.109 0 1.872-.407.764-.405 1.257-1.12l1.971 1.576q-1.749 2.366-5.076 2.366-1.38 0-2.538-.431a6 6 0 0 1-2.008-1.22 5.5 5.5 0 0 1-1.33-1.934q-.48-1.145-.481-2.6 0-1.43.48-2.6t1.319-1.995a5.9 5.9 0 0 1 1.983-1.282 6.6 6.6 0 0 1 2.477-.455q1.23 0 2.279.406a4.94 4.94 0 0 1 1.81 1.208q.764.801 1.196 1.995.43 1.196.431 2.797m10.053 4.263h-.074q-.443.788-1.429 1.293-.985.505-2.242.505-.714 0-1.491-.184a4.4 4.4 0 0 1-1.429-.616 3.6 3.6 0 0 1-1.084-1.134q-.431-.702-.431-1.737 0-1.33.751-2.119.752-.789 1.934-1.207a11 11 0 0 1 2.625-.555q1.441-.135 2.821-.135v-.296q0-1.11-.801-1.638-.8-.53-1.909-.53-.937 0-1.799.394-.863.394-1.429.961l-1.528-1.799a6.7 6.7 0 0 1 2.328-1.404 8 8 0 0 1 2.674-.468q1.577 0 2.599.443 1.023.444 1.614 1.158.592.715.826 1.602a7 7 0 0 1 .234 1.774v7.195h-2.76zm-.049-3.893h-.665q-.715 0-1.503.061a6.5 6.5 0 0 0-1.454.271q-.666.21-1.109.592-.444.381-.443 1.047 0 .42.184.702.186.284.481.456.296.172.665.246t.739.074q1.529 0 2.316-.813.789-.813.789-2.217zm5.378-6.431h2.834v1.97h.049a4.3 4.3 0 0 1 1.38-1.675q.887-.64 2.07-.64.172 0 .37.012.196.012.345.062v2.71a3.473 3.473 0 0 0-.912-.123q-1.011 0-1.626.37a2.95 2.95 0 0 0-.961.886q-.345.518-.469 1.06a4 4 0 0 0-.123.862v6.333h-2.957zm11.976-6.801v8.304h.073q.222-.296.567-.616t.826-.592q.48-.27 1.121-.456a5.2 5.2 0 0 1 1.453-.184q1.257 0 2.317.48t1.823 1.318a6 6 0 0 1 1.183 1.972q.419 1.133.419 2.439t-.407 2.452a6 6 0 0 1-1.158 1.995 5.6 5.6 0 0 1-1.823 1.356q-1.072.505-2.427.505a5.24 5.24 0 0 1-2.354-.542 4.03 4.03 0 0 1-1.712-1.577h-.049v1.774h-2.809V13.292zm6.776 12.665q0-.69-.21-1.368a3.8 3.8 0 0 0-.628-1.22 3.2 3.2 0 0 0-1.06-.874q-.64-.333-1.503-.333a3 3 0 0 0-1.454.345 3.72 3.72 0 0 0-1.786 2.12q-.234.69-.234 1.38t.234 1.367.69 1.22a3.6 3.6 0 0 0 1.096.874q.642.333 1.454.333.862 0 1.503-.345t1.06-.887q.418-.542.628-1.232t.21-1.38m5.033-5.864h2.957V31.92h-2.957zm-.419-4.017q0-.714.53-1.244t1.343-.53 1.367.505q.555.505.555 1.27 0 .762-.555 1.268-.554.505-1.367.505t-1.343-.53q-.53-.528-.53-1.244m5.273 6.382v-2.365h2.07v-3.425h2.907v3.425h2.957v2.365h-2.957v5.495q0 .787.284 1.306.283.517 1.269.517.295 0 .64-.061.345-.062.616-.185l.099 2.316a5 5 0 0 1-.936.234 6.6 6.6 0 0 1-1.035.086q-1.183 0-1.922-.332a2.9 2.9 0 0 1-1.171-.912 3.4 3.4 0 0 1-.591-1.33 7.7 7.7 0 0 1-.16-1.615v-5.519z"
      />
    </g>
    <defs>
      <linearGradient
        id="Logo_Clearbit_svg__b"
        x1={33.615}
        x2={44.615}
        y1={24}
        y2={46}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DEF2FE" />
        <stop
          offset={1}
          stopColor="#DBF1FE"
        />
      </linearGradient>
      <linearGradient
        id="Logo_Clearbit_svg__c"
        x1={22.615}
        x2={33.615}
        y1={2}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#57BCFD" />
        <stop
          offset={1}
          stopColor="#51B5FD"
        />
      </linearGradient>
      <linearGradient
        id="Logo_Clearbit_svg__d"
        x1={8.865}
        x2={27.565}
        y1={2}
        y2={39.4}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1CA7FD" />
        <stop
          offset={1}
          stopColor="#148CFC"
        />
      </linearGradient>
      <clipPath id="Logo_Clearbit_svg__a">
        <path
          fill="#fff"
          d="M.615 0h150v48h-150z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoClearbit;
